import React, { useState } from "react";
import { Building2, ChevronDown } from "lucide-react";
import { Button } from "components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";

interface ClinicOption {
  value: string;
  label: string;
}

interface ClinicFilterDropdownProps {
  clinicFilter: string[];
  setClinicFilter: (filter: string[]) => void;
  availableClinics: ClinicOption[];
}

const ClinicFilterDropdown = ({
  clinicFilter,
  setClinicFilter,
  availableClinics,
}: ClinicFilterDropdownProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 text-xs">
          <Building2 className="mr-2 h-3 w-3" />
          Clinic
          {clinicFilter.length > 0 && (
            <span className="ml-1 bg-blue-100 text-blue-800 rounded-full px-1.5 py-0.5 text-xs">
              {clinicFilter.length}
            </span>
          )}
          <ChevronDown className="ml-1 h-3 w-3" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-0" align="start">
        <div className="p-2">
          <div className="text-sm font-medium text-gray-700 mb-2">
            Filter by Clinic
          </div>
          <div className="space-y-1 max-h-64 overflow-y-auto">
            {availableClinics.length > 0 ? (
              availableClinics.map((clinic) => (
                <label
                  key={clinic.value}
                  className="flex items-start space-x-2 p-1 hover:bg-gray-50 rounded cursor-pointer"
                >
                  <div className="flex items-center h-5">
                    <input
                      type="checkbox"
                      className="h-3 w-3 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      checked={clinicFilter.includes(clinic.value)}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (e.target.checked) {
                          setClinicFilter([...clinicFilter, clinic.value]);
                        } else {
                          setClinicFilter(
                            clinicFilter.filter((c) => c !== clinic.value)
                          );
                        }
                      }}
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-xs font-medium text-gray-900 break-words">
                      {clinic.label}
                    </div>
                  </div>
                </label>
              ))
            ) : (
              <div className="text-xs text-gray-500 p-2">
                No clinics available
              </div>
            )}
          </div>
          {clinicFilter.length > 0 && (
            <div className="mt-2 pt-2 border-t border-gray-100">
              <button
                onClick={() => setClinicFilter([])}
                className="text-xs text-gray-500 hover:text-gray-700"
              >
                Clear filters
              </button>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default ClinicFilterDropdown;
